// ** Initial State

import {sendApplyooComponentsNotification} from "../../../applyoo/infrastructure/useApplyooComponent";

const initialState = {
    lstNavHistory: [] ,
    currentLocation:''
}

export const store_Navigation  = (state = initialState, action) => {
    switch (action.type) {

        case 'NAVIGATE':
            if (!!action?.isRememberRoute) {
                localStorage["rememberRoute"] = `${window.location.pathname}${window.location?.search}`
            }

            if (state.lstNavHistory.length === 0
                    || state.lstNavHistory[state.lstNavHistory.length - 1] !== action.currentLocation) {
                state.lstNavHistory.push(action.currentLocation);
            }

            //localStorage.setItem('defaultRoute',action.currentLocation )
            return { ...state,  currentLocation: action.currentLocation }

        case 'NAVIGATE_BACK':
            if (state.lstNavHistory.length > 1) {
                const backUrl = state.lstNavHistory[state.lstNavHistory.length - 2]
                sendApplyooComponentsNotification("ApplyooGlobal", "ProjectFrameContainer", {command: "navigateToUrl", "urlStr": backUrl})
            }
            else {
                sendApplyooComponentsNotification("ApplyooGlobal", "ProjectFrameContainer", {command: "navigateToUrl", "urlStr": '*'})
            }

            //localStorage.setItem('defaultRoute',action.currentLocation )
            return { ...state,  currentLocation: action.currentLocation }
        default:
            return state
    }
}

// export default store_Navigation
